import './Section.scss'
import { ISectionHeader, SectionHeader } from '../SectionHeader/SectionHeader'

interface ISecondarySection {
  borderBottom?: boolean
  headerConfig: ISectionHeader
  children?: React.ReactNode
}

export const Section = ({
  borderBottom = true,
  headerConfig,
  children,
}: ISecondarySection) => {
  return (
    <div
      className="section-container"
      style={borderBottom ? { borderBottom: '1px solid' } : {}}
    >
      <SectionHeader
        title={headerConfig.title}
        description={headerConfig.description}
        inLine={headerConfig.inLine}
        maxWidth={headerConfig.maxWidth}
      ></SectionHeader>

      <div>{children}</div>
    </div>
  )
}
